import EditorSeparator from './editor-separator.component.js'

export * from './editor-separator.component.js'
export default EditorSeparator

EditorSeparator.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-separator': EditorSeparator
  }
}
